import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../redux/actions/authAction";
import { useNavigate } from "react-router-dom";
import notify from "../useNotifaction";
import validatePassword from "../../Feature/PassworValidRegex";

const ResetPasswordHook = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setComfirmPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const OnChangePassword = (e) => {
    setPassword(e.target.value);
  };
  const OnChangeConfirmPassword = (e) => {
    setComfirmPassword(e.target.value);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordConFirmVisibility = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };

  const isComplate =
    validatePassword(password).length === 0 &&
    validatePassword(confirmPassword).length === 0;

  const onSubmit = async () => {
    if (password === "") {
      notify("من فضلك ادخل كلمة السر", "error");
      return;
    }
    if (password !== confirmPassword) {
      notify("كلمة السر غير متطابقه مع تاكيد كلمع السر", "error");
      return;
    }

    setLoading(true);
    await dispatch(
      resetPassword({
        email: localStorage.getItem("user-email"),
        newPassword: password,
      })
    );
    setLoading(false);
  };

  const res = useSelector((state) => state.authReducer.verifyPassword);
  useEffect(() => {
    if (loading === false) {
      if (res) {
        if (res.data.status === "Success") {
          notify("تم تغير كلمة السر بنجاح", "success");
          setTimeout(() => {
            navigate("/login");
          }, 1500);
        }
        if (res.data.status === "fail") {
          notify("من فضلك اطلب كود جديد", "error");
        }
      }
    }
  }, [loading, navigate, res]);

  return [
    password,
    confirmPassword,
    OnChangePassword,
    OnChangeConfirmPassword,
    onSubmit,
    showPassword,
    showPasswordConfirm,
    togglePasswordVisibility,
    togglePasswordConFirmVisibility,
    isComplate,
  ];
};

export default ResetPasswordHook;
